import {JsonApiParams} from '@tisa-group/cdk';
import {
  UmpireGlobalPageElement,
  UmpireGlobalPageElementSlugEnum,
} from '@tisa-group/models';

export class LoadGlobalPageElementBySlug {
  static readonly type = '[Global Page Element] Load Global Page Element By Slug';

  constructor(
    readonly slug: UmpireGlobalPageElementSlugEnum,
    readonly params?: JsonApiParams,
  ) {}
}

export class SetGlobalPageElementBySlug {
  static readonly type = '[Global Page Element] Set Global Page Element By Slug';

  constructor(readonly globalPageElement: UmpireGlobalPageElement) {}
}
